import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InspectionWaterSupplyDataCase } from '@authority-labs/api-interfaces';
import { MeasureType } from '@authority-labs/enums';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-water-characteristics-case',
  templateUrl: './check-water-characteristics-case.component.html',
  styleUrls: ['./check-water-characteristics-case.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckWaterCharacteristicsCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionWaterSupplyDataCase;
  @Input() characteristics: MeasureType[] = [];

  charType = MeasureType;
}
